export interface TallyQuestionOption {
  id?: string;
  text?: string;
  image?: string;
  attachment?: string;
  [key: string]: any;
}

export interface TallyQuestion {
  id: string;
  type: string;
  title: string;
  description?: string;
  fields?: Record<string, any>[];
  properties?: Record<string, any>;
  options?: TallyQuestionOption[];
  required?: boolean;
  [key: string]: any;
}

export interface TallyFormQuestionsResponseData {
  data: {
    questions: TallyQuestion[];
  };
  meta: {
    code: number;
  };
}

export interface TallyQuestionMappingItem {
  question_id: string;
  question_title: string;
  question_type: string;
  field_type_id: string;
  tag_ids?: string[];
}

export interface TallyMappingPayload {
  account_id: string;
  form_id: string;
  form_name: string;
  mappings: TallyQuestionMappingItem[];
}

export const TALLY_MAPPING_FIELDS = {
  ACCOUNT_ID: "account_id",
  FORM_ID: "form_id",
  FORM_NAME: "form_name",
  QUESTION_ID: "question_id",
  QUESTION_TITLE: "question_title",
  QUESTION_TYPE: "question_type",
  FIELD_TYPE_ID: "field_type_id",
} as const;

export interface TallyForm {
  id: string;
  formId: string;
  name: string;
  accountId: string;
  archived: boolean;
  createdAt: string;
  updatedAt: string;
  refreshedAt: string | null;
}

export interface TallyQuestionMappingTag {
  id: string;
  name: string;
}

export interface TallyQuestionMappingResponse {
  id: string;
  questionId: string;
  questionTitle: string;
  questionType: string;
  fieldTypeId: string;
  fieldTypeName: string;
  fieldTypeParentName: string | null;
  fieldTypeDataType: string;
  isTypeMismatch: boolean;
  tags: TallyQuestionMappingTag[];
}

export interface TallyFormDetail extends TallyForm {
  mappings: TallyQuestionMappingResponse[];
}

export interface TallyFormDetailResponseData {
  data: { form: TallyFormDetail };
  meta: { code: number };
}

export interface TallyFormsResponseData {
  data: {
    forms: TallyForm[];
  };
  meta: {
    code: number;
  };
}
